
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<form class=\"film-search\" action=\"\">\r\n    <input class=\"film-search-input\" \r\n    type=\"text\" \r\n    placeholder=\"Search films\"\r\n     autocomplete=\"off\" />\r\n     <i class=\"material-icons white search-icon\">search</i>\r\n    <p>\r\n        <!-- fetch status -->\r\n    </p>\r\n</form>";
},"useData":true});
                export default templateFunction;
                